import { AxiosResponse } from "axios";
import { API_ENDPOINTS } from "../../../constants/api_endpoints";
import axios from "../../../lib/axios";
import { QData } from "../../../types/basic-type-list";
import { TResponse, TResponseWithQData } from "../../../types/common";
import { IAccountantPayloadType } from "../../../types/api/accontant-types";

export async function detailAccountant(
  id: string
): Promise<AxiosResponse<TResponse<IAccountantPayloadType>>> {
  return axios.get(`${API_ENDPOINTS.ACCOUNTANT_DETAIL}/${id}`);
}

export async function accountantList(
  qData: QData
): Promise<AxiosResponse<TResponseWithQData<IAccountantPayloadType[]>>> {
  return axios.get(API_ENDPOINTS.ACCOUNTANT_LIST, {
    params: qData,
  });
}

export async function createAccountant(
  payload: IAccountantPayloadType
): Promise<AxiosResponse<TResponse<IAccountantPayloadType>>> {
  return axios.post(API_ENDPOINTS.ACCOUNTANT_CREATE, payload);
}

export async function updateAccountant(
  payload: IAccountantPayloadType
): Promise<AxiosResponse<TResponse<IAccountantPayloadType>>> {
  return axios.put(API_ENDPOINTS.ACCOUNTANT_UPDATE, payload);
}
